import { useEffect, useState } from "react";
import DashboardLayout from "../../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Stack,
  Switch,
} from "@mui/material";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialBox from "../../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../../components/MaterialInput";
import MaterialButton from "../../../../../components/MaterialButton";
import ImageUpload from "../../../../../components/UploadImage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchDataById, postData } from "../../../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { fetchData, putData } from "../../../../../services";
import { useLoading } from "../../../../../components/Loading";
import { useSnackbar } from "../../../../../context/popup";
import MaterialSelect from "../../../../../components/MasterSelect";
import DropDownConfig from "../../../../Utils/DropDownConfig";

const AddMotorMake = () => {
  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const location = useLocation();
  const params = useParams();
  const paramId = params.id;

  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [makeData, setMakeData] = useState({
    // make information
    name: "",
    motorCategoryId: "",
    isActive: true,
    logo: null,

    // make information status
    nameStatus: "unchecked",
    motorCategoryIdStatus: "unchecked"
  });
  
  const [logoPreview, setLogoPreview] = useState(null);
  const [motorCategoryOptions, setMotorCategoryOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (location.state) {
        if (location.state.isEdit) {
          setIsEdit(true);
        } else if (location.state.isView) {
          setIsView(true);
        }

        if (paramId) {
          setCircleLoading(true);
          try {
            await fetchDataById(`/reference/motor/mmv/make/${paramId}`).then(
              (res) => {
                const responseData = res?.data;

                setMakeData((prevData) => ({
                  ...prevData,
                  name: responseData?.name,
                  logo: responseData?.logo,
                  motorCategoryId: {label: responseData?.motorCategory?.keyName, value: responseData?.motorCategory?.id},
                  isActive: responseData?.isActive,

                  nameStatus: responseData?.name ? "success" : "unchecked",
                  motorCategoryIdStatus: responseData?.motorCategory?.id ? "success" : "unchecked"
                }));
                setLogoPreview(responseData?.logo || null);
              }
            );
          } catch (error) {
            console.error("Error Fetching Data:",error);
            showSnackbar(error?.response?.data?.message || "Error Fetching Data","error")
          } finally {
            setCircleLoading(false);
          }
        }
      }
    };

    fetchData();
  }, [location, params.id]);

  useEffect(() => {
    fetchMotorCategoryList();
  },[])
  const fetchMotorCategoryList = async () => {
      setCircleLoading(true);
      try {
          const response = await fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.motorCategory}`)

          if(response?.success){
              const formattedOptions = response?.data?.items?.map((item) => ({
                  value: item.id,
                  label: item.keyName,
              }));
              setMotorCategoryOptions(formattedOptions)
          }
          else{
              //throw error
              showSnackbar("Error Fetching Motor Category", "error")
          }
      } catch (error) {
          console.error('Error Fetching Data:', error);
          showSnackbar(error?.response?.data?.message || "Error Fetching Motor Category", "error")
      }
      finally{
          setCircleLoading(false);
      }
  };

const handleMakeDataChange = (event, selectEvent) => {
  let makeState = { ...makeData };
  const changeAllowed = true;

  // ✅ SELECT HANDLING
  if (!event?.target && selectEvent) {
    switch (selectEvent.name) {
      case "motorCategoryId": {
        const regex = /^[\s\S]{1,170}$/;

        if (regex.test(event?.trim?.())) {
          makeState[selectEvent.name + "Status"] = "success";
        } else {
          makeState[selectEvent.name + "Status"] =
            event === "" ? "unchecked" : "error";
        }
        break;
      }
    }

    // ✅ safe assignment
    makeState[selectEvent.name] = event;
  }

  // ✅ INPUT HANDLING
  else if (event?.target) {
    const { name, value } = event.target;

    switch (name) {
      case "name": {
        const regex = /^[A-Za-z0-9 ]{2,20}$/;

        if (regex.test(value?.trim())) {
          makeState[name + "Status"] = "success";
        } else {
          makeState[name + "Status"] =
            value === "" ? "unchecked" : "error";
        }
        break;
      }

      default:
        break;
    }

    // ✅ safe assignment
    if (changeAllowed) {
      makeState[name] = value;
    }
  }

  setMakeData(makeState);
};

  const handleImageChange = (file, name) => {
    setMakeData((prevData) => ({
      ...prevData,
      [name]: file,
    }));
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (makeData.nameStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddMake = async () => {
    //Update Functionality
    const formData = new FormData();

    formData.append("name", makeData.name);
    formData.append("isActive", makeData.isActive);
    formData.append("motorCategoryId",makeData?.motorCategoryId?.value)

    if (makeData.logo instanceof File) {
      formData.append("logo", makeData.logo);
    }
    if (isEdit) {
      try {
        const reponse = await putData(
          `/reference/motor/mmv/make/${paramId}`,
          formData
        );
        const successResponse = reponse?.success;
        if (successResponse) {
          showSnackbar(reponse?.message,"success");
          navigate("/motor-master/motor-MMV");
        } else {
          showSnackbar("Failed to Update");
        }
      } catch (error) {
        console.error("Error updating",error);
        showSnackbar(error?.response?.data?.message || "Network Error","error");
      }
    }
    //Create Functionality
    else {
      try {
        const reponse = await postData(
          "/reference/motor/mmv/make",
          formData
        );
        const successResponse = reponse?.success;
        if (successResponse) {
          showSnackbar(reponse?.message,"success");
          navigate("/motor-master/motor-MMV");
        } else {
          showSnackbar("Failed to create");
        }
      } catch (error) {
        console.error("Error Submitting",error);
        showSnackbar(error?.response?.data?.message || "Network Error","error");
      }
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {isEdit ? "Edit" : isView ? "View" : "Add"} Make details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    {isEdit ? "Edit" : isView ? "View" : "Add"} Make Details
                    here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Make Name*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  placeholder="eg. Locomotive"
                  value={makeData.name}
                  onChange={handleMakeDataChange}
                  error={makeData.nameStatus === "error" ? true : false}
                  success={makeData.nameStatus === "success" ? true : false}
                  disabled={isView}
                />
                {makeData.nameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be maximum 20 characters long and can contain
                      only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Motor Product*
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="motorCategoryId"
                  value={makeData.motorCategoryId}
                  options={motorCategoryOptions}
                  onChange={handleMakeDataChange}
                  error={makeData.motorCategoryIdStatus === "error" ? true : false}
                  success={makeData.motorCategoryIdStatus === "success" ? true : false}
                  isDisabled={isView}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Brand Logo
                  </MaterialTypography>
                </MaterialBox>
                <ImageUpload
                  name={"logo"}
                  onImageUpload={handleImageChange}
                  imageProps={logoPreview}
                  viewPage={isView}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Active
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  control={
                    <Switch
                      checked={makeData.isActive}
                      onChange={(e) =>
                        handleMakeDataChange({
                          target: {
                            name: "isActive",
                            value: e.target.checked,
                          },
                        })
                      }
                      disabled={isView}
                      color="primary"
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {makeData.isActive ? "Yes" : "No"}
                    </MaterialTypography>
                  }
                  sx={{ marginLeft: 0 }}
                />
              </Grid>              
            </Grid>
          </MaterialBox>
        </CardContent>
        {isView ? null : (
          <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="outlined"
              color="dark"
              onClick={() => {
                window.history.back();
              }}
            >
              Cancel
            </MaterialButton>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddMake}
            >
              {isEdit ? "Update" : "Submit"}
            </MaterialButton>
          </MaterialBox>
        )}
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorMake;
